var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { "margin-top": "1em !important" } },
    [
      _c(
        "sui-table",
        { attrs: { basic: "very", selectable: "" } },
        [
          _c(
            "sui-table-header",
            [
              _c(
                "sui-table-row",
                [
                  _c("sui-table-header-cell"),
                  _vm._l(_vm.columns, function (column, index) {
                    return _c("sui-table-header-cell", { key: index }, [
                      _vm._v(" " + _vm._s(column.text) + " "),
                    ])
                  }),
                  _c("sui-table-header-cell"),
                ],
                2
              ),
            ],
            1
          ),
          _vm.firms
            ? _c(
                "sui-table-body",
                _vm._l(_vm.firms, function (firm, index) {
                  return _c(
                    "sui-table-row",
                    { key: index },
                    [
                      _c("sui-table-cell", { attrs: { collapsing: "" } }, [
                        _vm._v(_vm._s(index + 1)),
                      ]),
                      _c(
                        "sui-table-cell",
                        [
                          _c(
                            "sui-header",
                            { tag: "h4" },
                            [
                              _c("sui-icon", {
                                attrs: { name: "building", color: "grey" },
                              }),
                              _c(
                                "sui-header-content",
                                [
                                  _vm._v(" " + _vm._s(firm.name) + " "),
                                  _c("sui-header-subheader", [
                                    _vm._v(_vm._s(firm.abbreviation)),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("sui-table-cell", [_vm._v(_vm._s(firm.street))]),
                      _c("sui-table-cell", [_vm._v(_vm._s(firm.city))]),
                      _c("sui-table-cell", [_vm._v(_vm._s(firm.state))]),
                      _c("sui-table-cell", [_vm._v(_vm._s(firm.zip_code))]),
                      _c(
                        "sui-table-cell",
                        [
                          _c(
                            "sui-dropdown",
                            { attrs: { pointing: "center left" } },
                            [
                              _c(
                                "sui-dropdown-menu",
                                [
                                  _c(
                                    "sui-dropdown-item",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.getFirm(firm.id)
                                        },
                                      },
                                    },
                                    [_vm._v("View")]
                                  ),
                                  _c(
                                    "sui-dropdown-item",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.getFirm(firm.id)
                                        },
                                      },
                                    },
                                    [
                                      _c("sui-icon", {
                                        attrs: { name: "pencil square" },
                                      }),
                                      _vm._v("Edit "),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "sui-dropdown-item",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.showDeleteAlert(firm)
                                        },
                                      },
                                    },
                                    [
                                      _c("sui-icon", {
                                        attrs: { name: "trash" },
                                      }),
                                      _vm._v("Delete "),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }